import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUp, ArrowLeft, ArrowRight, Footprints } from 'lucide-react';
export function InteriorFloatingControls() {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="absolute top-1/2 -translate-y-1/2 left-[340px] z-30 flex flex-col gap-2" data-id="element-278">
      <div className="flex flex-col bg-slate-900/80 backdrop-blur-md rounded-lg border border-white/10 overflow-hidden shadow-xl" data-id="element-279">
        <button className="flex items-center gap-3 px-4 py-3 text-white/70 hover:text-white hover:bg-white/10 transition-colors border-b border-white/5 text-left group" data-id="element-280">
          <ArrowUp className="w-4 h-4 text-cyan-500" data-id="element-281" />
          <span className="text-xs font-medium uppercase tracking-wider" data-id="element-282">
            Last
          </span>
        </button>
        <button className="flex items-center gap-3 px-4 py-3 text-white hover:bg-white/10 transition-colors border-b border-white/5 text-left bg-white/5" data-id="element-283">
          <Footprints className="w-4 h-4 text-cyan-500" data-id="element-284" />
          <span className="text-xs font-medium uppercase tracking-wider" data-id="element-285">
            Walk Mode
          </span>
        </button>
        <button className="flex items-center gap-3 px-4 py-3 text-white/70 hover:text-white hover:bg-white/10 transition-colors text-left group" data-id="element-286">
          <ArrowRight className="w-4 h-4 text-cyan-500" data-id="element-287" />
          <span className="text-xs font-medium uppercase tracking-wider" data-id="element-288">
            Next
          </span>
        </button>
      </div>
    </motion.div>;
}